export const PREVIEW = 'PREVIEW'
export const VALIDATE_VALUES = 'VALIDATE_VALUES'
export const BOOK = 'BOOK'
export const SIMULATE = 'SIMULATE'
